module.exports = "https://trybtryb-legacy.web.app/img/grey-mist.59186d41.webp";